<template>
  <div class="registration">
    <div class="mt_bl" v-show="!codeView">
      <v-text-field
          label="Электронная почта"
          class="inpt"
          hide-details="auto"
          name="mail"
          v-model.trim="login"
      >
      </v-text-field>
      <div class="error" v-if="$v.login.$dirty && !$v.login.required">Поле логин обязательно к заполнению</div>
      <div class="error" v-if="!$v.login.minLength">Поле логин минимальная длина 10 символов</div>

      <v-text-field
          label="Контактный телефон"
          class="inpt"
          hide-details="auto"
          name="contact_phone"
          v-model.trim="contact_phone"
      >
      </v-text-field>
      <div class="error" v-if="$v.contact_phone.$dirty && !$v.contact_phone.required">Поле телефон обязательно к заполнению</div>
      <div class="error" v-if="!$v.contact_phone.minLength">Поле телефон минимальная длина 10 символов</div>
      <div class="error" v-if="!$v.contact_phone.maxLength">Поле телефон максимальная длина 20 символов</div>

      <v-text-field
          label="Пароль"
          class="inpt"
          hide-details="auto"
          v-model.trim="password"
          name="password"
          type="password"
      ></v-text-field>
      <div class="error" v-if="$v.password.$dirty && !$v.password.required">Поле пароль обязательно к заполнению</div>
      <div class="error" v-if="!$v.password.minLength">Минимальная длина пароля 4 символов.</div>
      <div class="error" v-if="!$v.confirm_password.sameAs">Пароли не совпадают</div>

      <v-text-field
          label="Повторите пароль"
          class="inpt"
          hide-details="auto"
          v-model.trim="confirm_password"
          type="password"
      ></v-text-field>
      <div class="error" v-if="$v.confirm_password.$dirty && !$v.confirm_password.required">Поле повторите пароль
        обязательно к заполнению
      </div>
      <div class="error" v-if="!$v.confirm_password.sameAs">Пароли не совпадают</div>

      <button
          class="btn"
          @click="registarations"
      >
                <span v-show="!viewLoader">
                    Регистрация
                </span>
        <v-progress-circular v-show="viewLoader" class="loader__color" indeterminate size="24"></v-progress-circular>
      </button>
      <a @click="reg">
        Вход
      </a>
    </div>
    <div class="mt_bl" v-show="codeView">
      <div v-show="!viewSucces" class="sms_confirm">
        <p>На вашу почту отправлен код для подтверждения</p>
        <CodeInput
            :loading="false"
            :fieldWidth="56"
            class="input_verif"
            v-on:change="onChange"
            :autoFocus="true"
        />
        <CodeInput
            :loading="false"
            :fieldWidth="35"
            :fieldHeight="35"
            class="input_verif_mob"
            v-on:change="onChange"
            :autoFocus="true"
        />
        <button class="btn" :disabled="isDisabled" @click="smsConfirm">Проверить</button>
        <a @click="codeReview">
          Назад
        </a>
      </div>

      <div v-show="viewSucces" class="success_registaration">
        <p>
          Вы успешно зарегистрированы! Для входа в личный кабинет введите логин и пароль
        </p>
        <a class="success_registaration_auth" @click="reg">
          Вход
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import CodeInput from "vue-verification-code-input";
import axios from 'axios'
import {required, minLength, maxLength, sameAs} from 'vuelidate/lib/validators'

export default {
  name: 'registration',
  components: {CodeInput},
  validations: {
    login: {
      required, minLength: minLength(10)
    },
    contact_phone: {
      required, minLength: minLength(11), maxLength: maxLength(20)
    },
    password: {
      required, minLength: minLength(4)
    },
    confirm_password: {
      required,
      sameAs: sameAs('password')
    }
  },
  data() {
    return {
      login: '',
      contact_phone: '',
      password: '',
      confirm_password: '',
      codeView: false,
      viewLoader: false,
      isDisabled: true,
      code: '',
      viewSucces: false,
    }
  },
  methods: {
    codeReview() {
      this.codeView = false
    },
    reg() {
      this.$emit('reg')
      this.viewSucces = false
    },
    registarations() {
      if (this.$v.$invalid) {
        this.$v.$touch()
        return
      } else {
        this.viewLoader = true
        axios({
          method: 'post',
          headers: {'Content-Type': 'application/x-www-form-urlencoded'},
          url: this.$apiURI + 'public/register',
          data: {
            login: this.login,
            contact_phone: this.contact_phone,
            password: this.password,
            confirm_password: this.confirm_password
          }
        })
            .then((response) => {
              this.viewLoader = false
              if (response.data.message == "User with this login already exists") {
                this.$toasted.show('Номер уже зарегистрирован!').goAway(2000)
              }
              if (response.data.message == "Registered successfully.") {
                this.codeView = true
                this.password = ''
                this.confirm_password = ''
              }
            })
            .catch((error) => {
              console.log(error);
            });
      }

    },
    smsConfirm() {
      axios({
        method: 'post',
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        url: this.$apiURI + 'public/smsconfirm',
        data: {
          phone: this.login,
          code: this.code
        }
      })
          .then((response) => {
            if (response.data.message == "Invalid code") {
              this.$toasted.show('Не верный код').goAway(2000)
            }
            if (response.data.message == "Successfully confirmed!") {
              this.login = ''
              this.viewSucces = true
            }

          })
          .catch((error) => {
            console.log(error);
          });
    },
    onChange(v) {
      if (v.length == 6) {
        this.code = v
        this.isDisabled = false
      }
    },
  }
}
</script>
<style scoped lang="less">
@baseMedia: 900px;
.registration {
  width: 100%;

  .mt_bl {
    .number_phone {
      position: relative;
      left: 0;
      font-size: 16px;
      top: 4px;
      font-weight: bold;
      margin-right: 5px;
    }

    .input_verif {
      display: block;
      margin: 0 auto;
      @media (max-width: @baseMedia) {
        display: none;
      }
    }

    .input_verif_mob {
      display: none;
      @media (max-width: @baseMedia) {
        display: block;
      }
    }

    .success_registaration {
      width: 100%;
      padding-top: 20px;
      padding-bottom: 20px;
      text-align: center;

      p {
        font-size: 16px;
      }

      .success_registaration_auth {
        color: #6b8e01;
        font-weight: bold;
        font-size: 17px;
      }
    }

    p {
      font-size: 14px;
      margin-bottom: 10px;
    }

    a {
      text-align: center;
      font-size: 14px;
      text-transform: uppercase;
      color: #000;
      cursor: pointer;
      display: block;
      margin: 0 auto;
    }

    .inpt {
      width: 100%;
    }

    .error {
      color: red;
      font-size: 11px;
      margin-top: 4px;
    }

    .btn {
      width: 100%;
      margin-top: 15px;
      margin-bottom: 10px;
      height: 40px;
      background: #90b913;
      color: #fff;
      text-transform: uppercase;
      font-size: 14px;

      &:hover {
        background: #8ba245;
      }

      .loader__color {
        color: #fff;
      }
    }
  }
}
</style>